import React, {Component, ErrorInfo, ReactNode} from 'react';
import {emitCounter, MetricMethod} from 'src/metrics';

interface Props {
    children?: ReactNode;
}

interface State {
    hasError: boolean;
}

/**
 * Top-level React error boundary. Catches render/lifecycle errors that would
 * otherwise blank the page while the server still serves HTTP 200, and emits a
 * JS-error counter so the failure is visible in monitoring. Counts only -- no
 * error message or stack is sent to metrics (this is an auth surface).
 */
class ErrorBoundary extends Component<Props, State> {
    state: State = {hasError: false};

    static getDerivedStateFromError(): State {
        return {hasError: true};
    }

    componentDidCatch(_error: Error, _info: ErrorInfo): void {
        emitCounter(MetricMethod.JsError, 'ReactError', 1);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div>
                    <h1>Something went wrong.</h1>
                    <h2>Please try again. If the problem continues, contact your site administrator.</h2>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
